import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const UserTabsComponent = React.lazy(() => import("../Components/RootComponents/UserTabsComponent"));
const TabsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <UserTabsComponent />
      </Suspense>
    </Fragment>
  );
};

export default TabsPage;
